<template>
  <div class="left-box">
    <div class="left-title">今日实时入场信息</div>
    <table class="left-table" cellspacing="0">
      <tr class="t-head">
        <!-- <td class="td-1">序号</td> -->
        <td class="td-2">时间</td>
        <td class="td-3">姓名</td>
        <td class="td-3">学号</td>
        <!-- <td class="td-4">状态</td> -->
      </tr>
    </table>
    <div style="height: 500px; overflow: hidden" @mouseenter="stopScroll" @mouseleave="startScroll">
      <table class="left-table" cellspacing="0" :class="{ 'animated-top': animatedTop && this.runData.length > 13 }">
        <tr
          class="tr-data"
          :class="{
            'color-tr': getBgClass(index),
            'mt-20': index == runData.length - 1,
          }"
          v-for="(item, index) in runData"
          :key="'run_' + index"
        >
          <!-- <td class="td-1">{{ item.code }}</td> -->
          <td class="college-name td-2 overflow">
            {{ item.date }}
          </td>
          <td class="td-3">{{ item.stuName }}</td>
          <td class="td-3">{{ item.stuNum }}</td>
          <!-- <td class="td-4">{{ item.ratio }}%</td> -->
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ['enterData'],
  data() {
    return {
      runData: [
        // { name: '计算机与计算科学', totalNum: 200, errorNum: 5 },
        // { name: '信息与电气工程', totalNum: 200, errorNum: 5 },
        // { name: '商学院', totalNum: 200, errorNum: 5 },
        // { name: '计算机与计算科学', totalNum: 200, errorNum: 5 },
        // { name: '信息与电气工程', totalNum: 200, errorNum: 5 },
        // { name: '商学院', totalNum: 200, errorNum: 5 },
        // { name: '计算机与计算科学', totalNum: 200, errorNum: 5 },
        // { name: '信息与电气工程', totalNum: 200, errorNum: 5 },
        // { name: '商学院', totalNum: 200, errorNum: 5 },
        // { name: '计算机与计算科学3', totalNum: 200, errorNum: 5 },
        // { name: '信息与电气工程2', totalNum: 200, errorNum: 5 },
        // { name: '商学院1', totalNum: 200, errorNum: 5 },
      ],
      animatedTop: false,
      timer: null,
      flag: true,
      modeData: 0,
    }
  },
  watch: {
    enterData: {
      handler: function () {
        this.runData = this.enterData

        // if(this.flag){
        //     for (let i = 0; i < this.runData.length; i++) {
        //         this.runData[i].code = i + 1
        //     }
        //     this.flag = false
        // }
      },
      deep: true,
    },
  },
  created() {
    this.runData = this.enterData
    // if (this.dayCollegeData.length > 10) {
    //   this.runData = [...this.dayCollegeData, ...this.dayCollegeData]
    // } else {
    //   this.runData = this.dayCollegeData
    // }
  },
  mounted() {
    const that = this
    setTimeout(() => {
      for (let i = 0; i < that.runData.length; i++) {
        that.runData[i].code = i + 1
      }
    }, 1000)

    this.timer = setInterval(() => {
      //   console.log('runData:', this.runData)
      if (this.runData.length > 13) {
        this.animatedTop = true
        setTimeout(() => {
          this.runData.push(this.runData[0])
          this.runData.shift()
          this.animatedTop = false
        }, 500)
      } else {
        this.stopScroll()
      }
    }, 2000)
  },
  computed: {
    getBgClass() {
      return function (index) {
        if (index % 2 == this.modeData) {
          return false
        }
        return true
      }
    },
  },
  methods: {
    stopScroll() {
      clearInterval(this.timer)
      this.timer = null
    },
    startScroll() {
      this.timer = setInterval(() => {
        if (this.runData.length > 13) {
          this.animatedTop = true
          setTimeout(() => {
            this.runData.push(this.runData[0])
            this.runData.shift()
            this.animatedTop = false
          }, 500)
        } else {
          this.stopScroll()
        }
      }, 2000)
    },
  },
}
</script>
<style scoped lang="scss">
.animated-top {
  transition: all 0.5s;
  margin-top: -30px;
}
.left-box {
  width: calc(100% - 48px);
  margin-left: 24px;
  .left-title {
    font-size: 22px;
    margin-bottom: 8px;
  }
  .left-table {
    width: calc(100% - 0px);
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 4px;
  }
}
table {
  table-layout: fixed;
  width: 100%;
  tr td {
    text-align: center;
    height: 30px;
    // height: 3vh;
  }
  .t-head {
    width: 100%;
    background: linear-gradient(0deg, rgba(6, 88, 58, 0.0884779) -24.83%, #06583a 100%);
    height: 36px;
    // height: 4vh;
  }
  tr {
    width: 100%;
    .td-1 {
      width: 33%;
    }
    .td-2 {
      width: 33%;
    }
    .td-3,
    .td-4 {
      width: 33%;
    }
  }
  .color-tr {
    background: rgba(0, 122, 77, 0.2);
  }
  //   .tr-data {
  //     .college-name {
  //       text-align: left;
  //     }
  //   }
}
.mt-20 {
  margin-bottom: 20px;
}
</style>
